import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

import ActivitiesTemplate from 'text!edge/claim/views/activities.html'; // PSA
import ActivityDetailTemplate from 'text!edge/claim/views/activity-detail.html'; // PSA
import ActivityDetailCtrl from 'edge/claim/controllers/ActivityDetailCtrl'; // PSA
import ActivitiesRrdiCtrl from 'edge/claim/controllers/ActivitiesRrdiCtrl'; //PSA

import GatewayHomeTemplate from 'text!../views/gateway-home.html';
import NewQuoteAccountSearchTemplate from 'text!../views/new-quote-account-search.html';
import NewQuoteTemplate from 'text!../views/new-quotePSA.html';
import AccountDetailTemplate from 'text!../views/account-detail.html';
import SearchTemplate from 'text!../views/search.html';
import PolicyDetailTemplate from 'text!../views/policy-detail.html';
import QuoteDetailTemplate from 'text!../views/quote-detail.html';
import RenewalDetailTemplate from 'text!../views/renewal-detail.html';
import EndorsementDetailTemplate from 'text!../views/endorsement-detail.html';
import CancellationDetailTemplate from 'text!../views/cancellation-detail.html';
import AccountLandingTemplate from 'text!../views/account-landing.html';
import AccountSummaryTemplate from 'text!../views/account/account-summary.html';
import ClaimsLandingTemplate from 'has-text?financials!../views/claims-landing.html';
import InvoicePaymentTemplate from 'text!edge/billing/views/invoice-payment.html';
import AccountActivitiesTemplate from 'text!../views/account/activities.html';
import AccountCommissionsTemplate from 'text!../views/account/commissions.html';
import AccountQuotesTemplate from 'text!../views/account/quotes.html';
import AccountClaimsTemplate from 'text!../views/account/claims.html';
import AccountContactsParentTemplate from 'text!../contacts/common/views/account-contacts-parent.html';
import AccountContactsTemplate from 'text!../contacts/common/views/account-contact-summary.html';
import RelatedAccountContactsTemplate from 'text!../contacts/common/views/related-account-contacts.html';
import AccountContactDetailTemplate from 'text!../contacts/common/views/account-contact-detail.html';
import AccountPolicyTransactionsTemplate from 'text!../views/account/policy-transactions.html';
import AccountNotesTemplate from 'text!../views/account/notes.html';
import AccountDocumentsTemplate from 'text!../views/account/documents.html';
import AccountBillingParentTemplate from 'text!../billingandpayment/views/billingParent.html';
import AccountBillingTemplate from 'text!../billingandpayment/views/billing.html';
import AccountPaymentTemplate from 'text!../billingandpayment/views/payment.html';
import JourneyPageTemplate from 'text!conditional?if=journey&equals=true!../journey/gateway-journey-page.html';
import PolicyLandingTemplate from 'text!../views/policy-landing.html';
import PolicySummaryTemplate from 'text!../views/policy/policy-summary.html';
import PolicyActivitiesTemplate from 'text!../views/policy/policy-activities.html';
import PolicyNotesTemplate from 'text!../views/policy/policy-notes.html';
import PolicyDocumentsTemplate from 'text!../views/policy/policy-documents.html';
import PolicyClaimsTemplate from 'text!../views/policy/policy-claims.html';
import PolicyBillingTemplate from 'text!../views/policy/policy-billing.html';
import PolicyCommissionsTemplate from 'text!../views/policy/policy-commissions.html';
import PolicyComplaintActivityTemplate from 'text!../views/policy/policy-complaint-activity.html';
import PolicyContactParentTemplate from 'text!../contacts/common/views/policy-contact-parent.html';
import PolicyContactSummaryTemplate from 'text!../contacts/common/views/policy-contact-summary.html';
import PolicyContactRelatedTemplate from 'text!../contacts/common/views/policy-contact-related.html';
import PolicyContactAccountTemplate from 'text!../contacts/common/views/policy-contact-account.html';
import PolicyContactDetailTemplate from 'text!../contacts/common/views/policy-contact-detail.html';
import PreferencesTemplate from 'text!../views/preferences.html';
import QuoteSummaryTemplate from 'text!../views/quote/quote-summary.html';
import QuoteNotesTemplate from 'text!../views/quote/quote-notes.html';
import QuoteDocumentsTemplate from 'text!../views/quote/quote-documents.html';
import QuoteActivitiesTemplate from 'text!../views/quote/quote-activities.html';
import RenewalSummaryTemplate from 'text!../views/renewal/renewal-summary.html';
import RenewalNotesTemplate from 'text!../views/renewal/renewal-notes.html';
import RenewalDocumentsTemplate from 'text!../views/renewal/renewal-documents.html';
import RenewalActivitiesTemplate from 'text!../views/renewal/renewal-activities.html';
import EndorsementSummaryTemplate from 'text!../views/endorsement/endorsement-summary.html';
import EndorsementNotesTemplate from 'text!../views/endorsement/endorsement-notes.html';
import EndorsementDocumentsTemplate from 'text!../views/endorsement/endorsement-documents.html';
import EndorsementActivitiesTemplate from 'text!../views/endorsement/endorsement-activities.html';
import CancellationSummaryTemplate from 'text!../views/cancellation/cancellation-summary.html';
import CancellationNotesTemplate from 'text!../views/cancellation/cancellation-notes.html';
import CancellationDocumentsTemplate from 'text!../views/cancellation/cancellation-documents.html';
import CancellationActivitiesTemplate from 'text!../views/cancellation/cancellation-activities.html';
import ActivitiesLandingTemplate from 'text!../views/activities-landing.html';
import ReportsTemplate from 'text!../views/gateway-reports.html';
import CommissionsTemplate from 'text!../views/gateway-commissions.html';
import setupStreamAutopayTemplate from 'text!edge/gateway/views/gateway-setup-stream-autopay.html';
import autoPayConfirmationTemplate from 'text!edge/billing/views/setup-autopay-confirmation.html';
import GatewayHomeCtrl from '../controllers/GatewayHomeCtrl';
import NewQuoteAccountSearchCtrl from '../controllers/NewQuoteAccountSearchCtrl';
import NewQuoteCtrl from '../controllers/NewQuoteCtrlPSA';
import AccountDetailCtrl from '../controllers/AccountDetailCtrl';
import SearchCtrl from '../controllers/SearchCtrl';
import PolicyDetailCtrl from '../controllers/PolicyDetailCtrl';
import QuoteDetailCtrl from '../controllers/QuoteDetailCtrl';
import RenewalDetailCtrl from '../controllers/RenewalDetailCtrl';
import EndorsementDetailCtrl from '../controllers/EndorsementDetailCtrl';
import CancellationDetailCtrl from '../controllers/CancellationDetailCtrl';
import AccountLandingCtrl from '../controllers/AccountLandingCtrl';
import ClaimsLandingCtrl from '../controllers/ClaimsLandingCtrl';
import AccountSummaryCtrl from '../controllers/account/AccountSummaryCtrl';
import InvoicePaymentCtrl from 'edge/billing/controllers/InvoicePaymentCtrl';
import AccountActivitiesCtrl from '../controllers/account/ActivitiesCtrl';
import AccountQuotesCtrl from '../controllers/account/QuotesCtrl';
import AccountClaimsCtrl from '../controllers/account/ClaimsCtrl';
import AccountContactsParentCtrl from '../contacts/common/controllers/AccountContactsParentCtrl';
import AccountContactsCtrl from '../contacts/common/controllers/AccountContactsCtrl';
import AccountContactDetailCtrl from '../contacts/common/controllers/AccountContactDetailCtrl';
import JourneyPageCtrl from 'conditional?if=journey&equals=true!edge/journey/controllers/JourneyPageCtrl';
import AccountPolicyTransactionsCtrl from '../controllers/account/PolicyTransactionsCtrl';
import AccountNotesCtrl from '../controllers/account/NotesCtrl';
import AccountDocumentsCtrl from '../controllers/account/DocumentsCtrl';
import AccountBillingParentCtrl from '../billingandpayment/controllers/BillingParentCtrl';
import PolicyLandingCtrl from '../controllers/PolicyLandingCtrl';
import PolicySummaryCtrl from '../controllers/policy/PolicySummaryCtrl';
import PolicyActivitiesCtrl from '../controllers/policy/PolicyActivitiesCtrl';
import PolicyNotesCtrl from '../controllers/policy/PolicyNotesCtrl';
import PolicyDocumentsCtrl from '../controllers/policy/PolicyDocumentsCtrl';
import PolicyClaimsCtrl from '../controllers/policy/PolicyClaimsCtrl';
import PolicyBillingCtrl from '../controllers/policy/PolicyBillingCtrl';
import PolicyContactParentCtrl from '../contacts/common/controllers/PolicyContactParentCtrl';
import PolicyContactSummaryCtrl from '../contacts/common/controllers/PolicyContactSummaryCtrl';
import PolicyContactDetailsCtrl from '../contacts/common/controllers/PolicyContactDetailsCtrl';
import PolicyRelatedAccountContactsCtrl from '../contacts/common/controllers/PolicyRelatedAccountContactsCtrl';
import PolicyContactAccountCtrl from '../contacts/common/controllers/PolicyContactAccountCtrl';
import PreferencesCtrl from '../controllers/PreferencesCtrl';
import QuoteSummaryCtrl from '../controllers/quote/QuoteSummaryCtrl';
import QuoteNotesCtrl from '../controllers/quote/QuoteNotesCtrl';
import QuoteDocumentsCtrl from '../controllers/quote/QuoteDocumentsCtrl';
import QuoteActivitiesCtrl from '../controllers/quote/QuoteActivitiesCtrl';
import RenewalSummaryCtrl from '../controllers/renewal/RenewalSummaryCtrl';
import RenewalNotesCtrl from '../controllers/renewal/RenewalNotesCtrl';
import RenewalDocumentsCtrl from '../controllers/renewal/RenewalDocumentsCtrl';
import RenewalActivitiesCtrl from '../controllers/renewal/RenewalActivitiesCtrl';
import EndorsementSummaryCtrl from '../controllers/endorsement/EndorsementSummaryCtrl';
import EndorsementNotesCtrl from '../controllers/endorsement/EndorsementNotesCtrl';
import EndorsementDocumentsCtrl from '../controllers/endorsement/EndorsementDocumentsCtrl';
import EndorsementActivitiesCtrl from '../controllers/endorsement/EndorsementActivitiesCtrl';
import CancellationSummaryCtrl from '../controllers/cancellation/CancellationSummaryCtrl';
import CancellationNotesCtrl from '../controllers/cancellation/CancellationNotesCtrl';
import CancellationDocumentsCtrl from '../controllers/cancellation/CancellationDocumentsCtrl';
import CancellationActivitiesCtrl from '../controllers/cancellation/CancellationActivitiesCtrl';
import ActivitiesLandingCtrl from '../controllers/ActivitiesLandingCtrl';
import SetupStreamAutopayCtrl from 'edge/billing/controllers/SetupStreamAutopayCtrl';
import SetupAutoPayConfirmationCtrl from 'edge/billing/controllers/SetupAutoPayConfirmationCtrl';
import GatewayReportsController from '../controllers/GatewayReportsController';
import GatewayCommissionsCtrl from '../controllers/GatewayCommissionsCtrl';
import PolicyComplaintActivityCtrl from '../controllers/policy/PolicyComplaintsCtrl';

export default (RootStates, isProducer) => {
    const parentState = RootStates.main_root;
    const billingState = 'billing-';
    const repairerOnlyPSA = !ApplicationFeatures.hasFeature('role.producer') && ApplicationFeatures.hasFeature('role.vendor');

    const commonRoutes = {
        gatewayLanding: {
            name: 'gatewayLanding',
            parent: parentState,
            url: '/home',
            controller: (repairerOnlyPSA ? ClaimsLandingCtrl : GatewayHomeCtrl), // PSA
            template: (repairerOnlyPSA ? ClaimsLandingTemplate : GatewayHomeTemplate), // PSA
            data: {
                errorMsg: null,
                actions: {
                    next: 'newQuoteSearch'
                }
            }
        },
        newQuote: {
            name: 'newQuote',
            parent: parentState,
            url: '/new-quote/{accountNumber}',
            template: NewQuoteTemplate,
            controller: NewQuoteCtrl,
            params: { accountNumber: '' },
            data: {
                actions: {
                    next: 'gatewayLanding'
                }
            }
        },
        newQuoteSearch: {
            name: 'newQuoteSearch',
            parent: parentState,
            url: '/new-quote-account-search/',
            template: NewQuoteAccountSearchTemplate,
            controller: NewQuoteAccountSearchCtrl,
            data: {
                actions: {
                    next: 'newQuote'
                }
            }
        },

        viewSearch: {
            name: 'viewSearch',
            parent: parentState,
            url: '/search/{searchParam}',
            template: SearchTemplate,
            controller: SearchCtrl,
            data: {
                label: 'Search',
                actions: {}
            }
        },


        // **** BEGIN - Accounts ****
        accountParent: {
            abstract: true,
            name: 'accounts',
            parent: parentState,
            url: '/accounts',
            template: '<ui-view/>'
        },

        viewAccount: {
            abstract: true,
            name: 'accounts.detail',
            url: '/{accountNumber}',
            template: AccountDetailTemplate,
            controller: AccountDetailCtrl,
            data: {
                label: 'View Account',
                actions: {}
            }
        },
        accountSummary: {
            name: 'accounts.detail.summary',
            url: '/summary',
            template: AccountSummaryTemplate,
            controller: AccountSummaryCtrl,
            data: {
                label: 'View Account',
                actions: {}
            }
        },

        accountActivities: {
            name: 'accounts.detail.activities',
            url: '/activities',
            template: AccountActivitiesTemplate,
            controller: AccountActivitiesCtrl,
            data: {
                label: 'Activities',
                actions: {}
            }
        },

        accountCommissions: {
            name: 'accounts.detail.commissions',
            url: '/commissions',
            template: AccountCommissionsTemplate,
            data: {
                label: 'Commission',
                actions: {}
            }
        },

        accountComplaintActivity: {
            name: 'accounts.detail.complaintActivity',
            url: '/complaintActivity',
            template: PolicyComplaintActivityTemplate,
            controller: PolicyComplaintActivityCtrl,
            data: {
                label: 'View Policy Complaints',
                actions: {}
            }
        },

        accountQuotes: {
            name: 'accounts.detail.quotes',
            url: '/quotes',
            template: AccountQuotesTemplate,
            controller: AccountQuotesCtrl,
            data: {
                label: 'Quotes',
                actions: {}
            }
        },

        accountClaims: {
            name: 'accounts.detail.claims',
            url: '/claims',
            template: AccountClaimsTemplate,
            controller: AccountClaimsCtrl,
            data: {
                label: 'Claims',
                actions: {}
            }
        },

        accountContactsParent: {
            redirectTo: 'accounts.detail.contacts.accountContacts',
            name: 'accounts.detail.contacts',
            url: '/contacts',
            template: AccountContactsParentTemplate,
            controller: AccountContactsParentCtrl,
            controllerAs: '$ctrl'
        },

        accountContacts: {
            name: 'accounts.detail.contacts.accountContacts',
            template: AccountContactsTemplate,
            controller: AccountContactsCtrl,
            controllerAs: '$ctrl',
            url: '/account',
            data: {
                label: 'Account Contacts',
                action: {}
            }
        },

        relatedContacts: {
            name: 'accounts.detail.contacts.relatedContacts',
            template: RelatedAccountContactsTemplate,
            controller: AccountContactsCtrl,
            controllerAs: '$ctrl',
            url: '/related',
            data: {
                label: 'Related Contacts',
                action: {}
            }
        },

        accountContactDetail: {
            name: 'accounts.detail.accountContactDetail',
            url: '/contacts/account/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'accounts.detail.contacts.accountContacts'
            }
        },

        relatedContactDetail: {
            name: 'accounts.detail.relatedContactDetail',
            url: '/contacts/related/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'accounts.detail.contacts.relatedContacts'
            }
        },

        accountPolicyTransactions: {
            name: 'accounts.detail.policy-transactions',
            url: '/work-orders',
            template: AccountPolicyTransactionsTemplate,
            controller: AccountPolicyTransactionsCtrl,
            data: {
                label: 'Claims',
                actions: {}
            }
        },

        accountNotes: {
            name: 'accounts.detail.notes',
            url: '/notes',
            template: AccountNotesTemplate,
            controller: AccountNotesCtrl,
            data: {
                label: 'Notes',
                actions: {}
            }
        },

        accountDocuments: {
            name: 'accounts.detail.documents',
            url: '/documents',
            template: AccountDocumentsTemplate,
            controller: AccountDocumentsCtrl,
            data: {
                label: 'Documents',
                actions: {}
            }
        },

        accountBillingAndPaymentParent: {
            redirectTo: 'accounts.detail.billingAndPayment.billing',
            name: 'accounts.detail.billingAndPayment',
            url: '/billingAndPayment',
            template: AccountBillingParentTemplate,
            controller: AccountBillingParentCtrl,
            controllerAs: '$ctrl'
        },

        accountBilling: {
            name: 'accounts.detail.billingAndPayment.billing',
            template: AccountBillingTemplate,
            controllerAs: '$ctrl',
            url: '/billing'
        },

        accountPayment: {
            name: 'accounts.detail.billingAndPayment.payment',
            template: AccountPaymentTemplate,
            controllerAs: '$ctrl',
            url: '/payment'
        },

        gatewayBillingSetupGroupAutopay: {
            name: 'accounts.detail.billingAndPayment.setup-autopay',
            url: '/setup-group-autopay/{streamId}',
            template: setupStreamAutopayTemplate,
            controller: SetupStreamAutopayCtrl,
            data: {
                actions: {
                    setupAutoPay: 'accounts.detail.billingAndPayment.setup-autopay-confirmation'
                }
            }
        },

        agentBillingSummary: {
            name: 'accounts.detail.payment',
            url: '/payments',
            abstract: 'true',
            template: '<ui-view/>'
        },

        agentBillingSetupAutopayConfirmation: {
            name: 'accounts.detail.billingAndPayment.setup-autopay-confirmation',
            url: '/setup-autopay-confirmation',
            template: autoPayConfirmationTemplate,
            controller: SetupAutoPayConfirmationCtrl,
            data: {
                actions: {
                    actions: {
                        cancel: 'accounts.detail.billingAndPayment'
                    }
                }
            },
            params: {
                info: {
                    value: null
                }
            }
        },

        // **** END - Accounts ****


        // **** START - Policies ****
        policyContactsParent: {
            redirectTo: 'policies.detail.contacts.policy',
            name: 'policies.detail.contacts',
            url: '/contacts',
            template: PolicyContactParentTemplate,
            controller: PolicyContactParentCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Contacts',
                action: {}
            }
        },

        policyContacts: {
            name: 'policies.detail.contacts.policy',
            url: '/policy',
            template: PolicyContactSummaryTemplate,
            controller: PolicyContactSummaryCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Contacts',
                action: {}
            }
        },

        policyAccountContacts: {
            name: 'policies.detail.contacts.account',
            url: '/account',
            template: PolicyContactAccountTemplate,
            controller: PolicyContactAccountCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Account Contacts',
                action: {}
            }
        },

        policyRelatedContacts: {
            name: 'policies.detail.contacts.related',
            url: '/related',
            template: PolicyContactRelatedTemplate,
            controller: PolicyRelatedAccountContactsCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Associated Contacts',
                action: {}
            }
        },

        policyAccountContactDetail: {
            name: 'policies.detail.account-contact-detail',
            url: '/account-contact/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'policies.detail.contacts.account'
            }
        },

        policyAssociatedContactDetail: {
            name: 'policies.detail.associated-contact-detail',
            url: '/associated-contact/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'policies.detail.contacts.related'
            }
        },

        policyContactDetail: {
            name: 'policies.detail.contact-detail',
            url: '/policy-contact/{contactNumber}',
            template: PolicyContactDetailTemplate,
            controller: PolicyContactDetailsCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Contacts',
                action: {}
            }

        },

        policyParent: {
            abstract: true,
            name: 'policies',
            parent: parentState,
            url: '/policies',
            template: '<ui-view/>'
        },

        viewPolicy: {
            abstract: true,
            name: 'policies.detail',
            url: '/{policyNumber}',
            template: PolicyDetailTemplate,
            controller: PolicyDetailCtrl,
            data: {
                label: 'View Policy',
                actions: {}
            }
        },

        policySummary: {
            name: 'policies.detail.summary',
            url: '/summary',
            template: PolicySummaryTemplate,
            controller: PolicySummaryCtrl,
            data: {
                label: 'View Policy',
                actions: {}
            }
        },

        policyActivities: {
            name: 'policies.detail.activities',
            url: '/activities',
            template: PolicyActivitiesTemplate,
            controller: PolicyActivitiesCtrl,
            data: {
                label: 'View Policy',
                actions: {}
            }
        },

        policyNotes: {
            name: 'policies.detail.notes',
            url: '/notes',
            template: PolicyNotesTemplate,
            controller: PolicyNotesCtrl,
            data: {
                label: 'View Policy Notes',
                actions: {}
            }
        },

        policyDocuments: {
            name: 'policies.detail.documents',
            url: '/documents',
            template: PolicyDocumentsTemplate,
            controller: PolicyDocumentsCtrl,
            data: {
                label: 'View Policy Documents',
                actions: {}
            }
        },

        policyClaims: {
            name: 'policies.detail.claims',
            url: '/claims',
            template: PolicyClaimsTemplate,
            controller: PolicyClaimsCtrl,
            data: {
                label: 'View Policy Claims',
                actions: {}
            }
        },
        policyBilling: {
            name: 'policies.detail.billing',
            url: '/billing',
            template: PolicyBillingTemplate,
            controller: PolicyBillingCtrl,
            data: {
                label: 'View Policy Billing',
                actions: {}
            }
        },
        policyCommissions: {
            name: 'policies.detail.commissions',
            url: '/commissions',
            params: {
                termNumber: null
            },
            template: PolicyCommissionsTemplate,
            data: {
                label: 'View Policy Commissions',
                actions: {}
            }
        },
        complaintActivity: {
            name: 'policies.detail.complaintActivity',
            url: '/complaintActivity',
            template: PolicyComplaintActivityTemplate,
            controller: PolicyComplaintActivityCtrl,
            data: {
                label: 'View Policy Complaints',
                actions: {}
            }
        },
        // **** END - Policies ****


        // **** START - QUOTES ****
        quoteParent: {
            abstract: true,
            name: 'quote',
            parent: parentState,
            url: '/quotes',
            template: '<ui-view/>'
        },

        viewQuote: {
            name: 'quote.detail',
            abstract: true,
            url: '/{submissionNumber}',
            template: QuoteDetailTemplate,
            controller: QuoteDetailCtrl,
            data: {
                label: 'View Quote',
                actions: {}
            }
        },

        quoteSummary: {
            name: 'quote.detail.summary',
            url: '/summary',
            template: QuoteSummaryTemplate,
            controller: QuoteSummaryCtrl,
            data: {
                label: 'View Quote Summary',
                actions: {}
            }
        },

        quoteActivities: {
            name: 'quote.detail.activities',
            url: '/activities',
            template: QuoteActivitiesTemplate,
            controller: QuoteActivitiesCtrl,
            data: {
                label: 'View Quote Activities',
                actions: {}
            }
        },
        quoteNotes: {
            name: 'quote.detail.notes',
            url: '/notes',
            template: QuoteNotesTemplate,
            controller: QuoteNotesCtrl,
            data: {
                label: 'View Quote Notes',
                actions: {}
            }
        },

        quoteDocuments: {
            name: 'quote.detail.documents',
            url: '/documents',
            template: QuoteDocumentsTemplate,
            controller: QuoteDocumentsCtrl,
            data: {
                label: 'View Quote Notes',
                actions: {}
            }
        },
        // **** END - QUOTES ****

        // **** START - RENEWAL ****
        renewalParent: {
            abstract: true,
            name: 'renewal',
            parent: parentState,
            url: '/renewals',
            template: '<ui-view/>'
        },

        viewRenewal: {
            name: 'renewal.detail',
            abstract: true,
            url: '/{renewalNumber}',
            template: RenewalDetailTemplate,
            controller: RenewalDetailCtrl,
            data: {
                label: 'View Renewal',
                actions: {}
            }
        },

        renewalSummary: {
            name: 'renewal.detail.summary',
            url: '/summary',
            template: RenewalSummaryTemplate,
            controller: RenewalSummaryCtrl,
            data: {
                label: 'View Renewal Summary',
                actions: {}
            }
        },

        renewalActivities: {
            name: 'renewal.detail.activities',
            url: '/activities',
            template: RenewalActivitiesTemplate,
            controller: RenewalActivitiesCtrl,
            data: {
                label: 'View Renewal Activities',
                actions: {}
            }
        },

        renewalNotes: {
            name: 'renewal.detail.notes',
            url: '/notes',
            template: RenewalNotesTemplate,
            controller: RenewalNotesCtrl,
            data: {
                label: 'View Renewal Notes',
                actions: {}
            }
        },

        renewalDocuments: {
            name: 'renewal.detail.documents',
            url: '/documents',
            template: RenewalDocumentsTemplate,
            controller: RenewalDocumentsCtrl,
            data: {
                label: 'View Renewal Notes',
                actions: {}
            }
        },
        // **** END - RENEWAL ****

        // **** START - ENDORSEMENTS ****
        endorsementParent: {
            abstract: true,
            name: 'endorsements',
            parent: parentState,
            url: '/endorsements',
            template: '<ui-view/>'
        },

        viewEndorsement: {
            name: 'endorsements.detail',
            abstract: true,
            url: '/{policyChangeNumber}',
            template: EndorsementDetailTemplate,
            controller: EndorsementDetailCtrl,
            data: {
                label: 'View Endorsement',
                actions: {}
            }
        },

        endorsementSummary: {
            name: 'endorsements.detail.summary',
            url: '/summary',
            template: EndorsementSummaryTemplate,
            controller: EndorsementSummaryCtrl,
            data: {
                label: 'View Endorsement Summary',
                actions: {}
            }
        },

        endorsementSummaryActivities: {
            name: 'endorsements.detail.activities',
            url: '/activities',
            template: EndorsementActivitiesTemplate,
            controller: EndorsementActivitiesCtrl,
            data: {
                label: 'View Endorsement Activities',
                actions: {}
            }
        },

        endorsementSummaryNotes: {
            name: 'endorsements.detail.notes',
            url: '/notes',
            template: EndorsementNotesTemplate,
            controller: EndorsementNotesCtrl,
            data: {
                label: 'View Endorsement Notes',
                actions: {}
            }
        },

        endorsementSummaryDocuments: {
            name: 'endorsements.detail.documents',
            url: '/documents',
            template: EndorsementDocumentsTemplate,
            controller: EndorsementDocumentsCtrl,
            data: {
                label: 'View Endorsement Notes',
                actions: {}
            }
        },
        // **** END - ENDORSEMENTS ****


        // **** START - CANCELLATIONS ****
        cancellationParent: {
            abstract: true,
            name: 'cancellation',
            parent: parentState,
            url: '/cancellation',
            template: '<ui-view/>'
        },

        viewCancellation: {
            name: 'cancellation.detail',
            abstract: true,
            url: '/{cancellationNumber}',
            template: CancellationDetailTemplate,
            controller: CancellationDetailCtrl,
            data: {
                label: 'View Cancellation',
                actions: {}
            }
        },

        cancellationSummary: {
            name: 'cancellation.detail.summary',
            url: '/summary',
            template: CancellationSummaryTemplate,
            controller: CancellationSummaryCtrl,
            data: {
                label: 'View Cancellation Summary',
                actions: {}
            }
        },

        cancellationSummaryActivities: {
            name: 'cancellation.detail.activities',
            url: '/activities',
            template: CancellationActivitiesTemplate,
            controller: CancellationActivitiesCtrl,
            data: {
                label: 'View Cancellation Activities',
                actions: {}
            }
        },

        cancellationSummaryNotes: {
            name: 'cancellation.detail.notes',
            url: '/notes',
            template: CancellationNotesTemplate,
            controller: CancellationNotesCtrl,
            data: {
                label: 'View Cancellation Notes',
                actions: {}
            }
        },

        cancellationSummaryDocuments: {
            name: 'cancellation.detail.documents',
            url: '/documents',
            template: CancellationDocumentsTemplate,
            controller: CancellationDocumentsCtrl,
            data: {
                label: 'View Cancellation Notes',
                actions: {}
            }
        },
        // **** END - CANCELLATIONS ****


        // **** START - Activities ****
        activityParent: {
            abstract: true,
            name: 'activities',
            parent: parentState,
            url: '/activities',
            template: '<ui-view/>'
        },

        activitiesLanding: {
            name: 'activities.index',
            url: '/',
            template: ActivitiesLandingTemplate,
            controller: ActivitiesLandingCtrl,
            data: {
                label: 'Activities',
                actions: {}
            }
        },
        // **** END - Activities ****


        // **** CC - Activities ****    PSA
        // extracted from: edge/claim/config/RouteConfig.js
        // added prefix "cc"
        ccActivity: {
            name: 'ccActivity',
            parent: parentState,
            abstract: true,
            url: '/cc-activities',
            template: '<div ui-view></div>'
        },
        ccActivitieslist: {
            name: 'ccActivitieslist',
            parent: 'ccActivity',
            url: '/list',
            template: ActivitiesTemplate,
            controller: ActivitiesRrdiCtrl,
            data: {
                label: 'Activities'
            }
        },
        ccViewActivity: {
            name: 'ccViewActivity',
            parent: 'ccActivity',
            url: '/detail/{activity}',
            template: ActivityDetailTemplate,
            controller: ActivityDetailCtrl,
            data: {
                label: 'View Activity',
                actions: {
                    claimDetails: 'claimDetails',
                    cancel: 'claimDetails'
                },
                trackingUrl: '/activity/detail'
            }
        },
        // **** END - CC Activities ****    PSA


        // **** START - Billing ****
        'gatewaybilling-invoice-payment': {
            name: `gateway${billingState}invoice-payment`,
            url: '/pay-invoices/{payMode}/{accountNumber}',
            parent: parentState,
            template: InvoicePaymentTemplate,
            controller: InvoicePaymentCtrl,
            data: {
                actions: {}
            }
        },
        // **** END - Billing ****


        'preferences': {
            name: 'preferences',
            url: '/preferences',
            parent: parentState,
            template: PreferencesTemplate,
            controller: PreferencesCtrl,
            data: {
                actions: {}
            }
        }
    };

    const agentRoutes = {
        // **** BEGIN - Accounts ****
        accountLanding: {
            name: 'accounts.index',
            url: '',
            template: AccountLandingTemplate,
            controller: AccountLandingCtrl,
            data: {
                label: 'Accounts',
                actions: {}
            }
        },
        // **** END - Accounts ****


        // **** START - Policies ****
        policyLanding: {
            name: 'policies.index',
            url: '/?quickFilter',
            template: PolicyLandingTemplate,
            controller: PolicyLandingCtrl,
            data: {
                label: 'Policies',
                actions: {}
            }
        },
        // **** END - Policies ****


        claimsLanding: {
            name: 'claims',
            url: '/claims',
            parent: parentState,
            template: ClaimsLandingTemplate,
            controller: ClaimsLandingCtrl,
            data: {
                label: 'Claims',
                actions: {}
            }
        },

        reportsLanding: {
            name: 'reports',
            url: '/analytics',
            parent: parentState,
            template: ReportsTemplate,
            controller: GatewayReportsController
        },

        commissionsLanding: {
            name: 'commissions',
            url: '/commissions',
            parent: parentState,
            template: CommissionsTemplate,
            controller: GatewayCommissionsCtrl
        }
    };

    if (ApplicationFeatures.hasFeature('journey')) {
        commonRoutes.accountJourney = {
            name: 'accounts.detail.journey',
            url: '/journey/timeline',
            template: JourneyPageTemplate,
            controller: JourneyPageCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Journey',
                action: {}
            }
        };
    }

    if (!isProducer) {
        return commonRoutes;
    }

    return angular.extend({}, commonRoutes, agentRoutes);
};
